import { Component, OnInit, Injector } from '@angular/core';
import { SignUpStep2Service } from './sign-up-step2.service';
import { PageFormComponent } from '../../../forms/page-form.component';
import { Color } from 'src/app/config/color';
import { RoutingDataService } from 'src/app/submodules/angular-common/routing-data.service';
import { NotificationDataService } from '../../../notification-data.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FormSettings } from '../../../forms/form-settings';
import { navigateToSamePage } from 'src/app/submodules/angular-common/util';
import { passwordAllowedSpecialCharacters } from 'src/app/config/security-config';

@Component({
  selector: 'app-sign-up-step2',
  templateUrl: './sign-up-step2.component.html',
  styleUrls: ['./sign-up-step2.component.scss'],
  providers:  [ SignUpStep2Service ]
})
export class SignUpStep2Component extends PageFormComponent {

  public bgColor = Color.auxiliary;
  public submitDone:boolean = false; //true se effettuato almeno un submit e quindi viene mostrato il messaggio di feedback

  passwordAllowedSpecialCharactersAsStr = passwordAllowedSpecialCharacters.join('');

  constructor(protected _injector: Injector){
    super(_injector);
  }

  ngOnInit(): void {
    this.init()
  }

  /** @override */
  async init() {
    console.log('SignUpStep2Component ngOnInit()');
    await super.init()
    //Call check-otp endpoint
    const result = await(this._injector.get(SignUpStep2Service).checkOtp(this._injector.get(RoutingDataService).currentUrlParams.otp as string));
    
    if(!result){
       this._injector.get(NotificationDataService).openSnackBar(this._injector.get(TranslateService).instant("AUTH.INVALID_OTP"));
       this._injector.get(Router).navigate(['/']);
    }
  }

  /** @override */
  protected async _initSettingsHook(): Promise<FormSettings> {
    return {
      fieldsSettings: {
        password: { required: true, allowBlanks: false },
        passwordConfirmation: { required: true, allowBlanks: false }
      }
    }
  }

  /** @override */
  protected async _setDatasourceHook(): Promise<{ [key: string]: string | number | boolean | (string | number)[] | File | File[]; }> {
    return {}
  }

  /** @override */
  protected async _submitHook() {

    
     //ritorna sempre 200 anche in caso di username non esistente per motivi di sicurezza

     try {

        await this._injector.get(SignUpStep2Service).signUp(this._injector.get(RoutingDataService).currentUrlParams.otp as string,
          this.currentValues.password as string,
          this.currentValues.passwordConfirmation as string,
          undefined);

       this._injector.get(NotificationDataService).openSnackBar(this._injector.get(TranslateService).instant("FORM.SUCCESSFUL_OPERATION"));
       
       this._injector.get(Router).navigate(['/']);
     } catch (error) {
       console.log('error :>> ', error);
       console.log('error :>> ', JSON.stringify(error));
       console.log('error.error.errorCode :>> ', error.error.errorCode);
       //Se 513 con error.code=OTP-NOT-VALID navighiamo su step1
        // errorCode: "AUTH.UNMATCHING_PASSWORD_CONFIRMATION"
        // message: "unmatching password confirmation"
        // path: "/auth/api/v1/reset-password"
        // status: 513
        // timeStamp: "2020-12-04T20:58:11.046Z"
        // type: "Generic Error"
        if(error.error.errorCode == 'AUTH.INVALID_OTP'){
          //triangolare per ricaricare la pagina
          navigateToSamePage(this._injector, "sign-up")
        }
        throw error; //in tutti i casi mostriamo il growl
     }
     
     this.submitDone = true
  }

  async cancel(){
    this._injector.get(Router).navigate(['/']);
  }
}
